import React, { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
function DesktopMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="34047" className="hidden lg:flex gap-6">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-5 w-20 bg-muted animate-pulse rounded-sm" />)}
      </div>;
  }
  return <NavigationMenu viewport={false} className="hidden lg:flex">
      <NavigationMenuList className="gap-8">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm font-medium text-foreground transition-all hover:text-accent hover:underline hover:decoration-accent underline-offset-8 decoration-2">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuConsumer({
  onClose
}: {
  onClose: () => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4 p-4">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-full bg-muted animate-pulse rounded-sm" />)}
      </div>;
  }
  return <nav className="flex flex-col gap-2 p-4">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="block py-3 text-lg font-medium text-foreground border-b border-border/30 hover:text-accent transition-colors" onClick={onClose}>
          {item.label}
        </Link>)}
    </nav>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
            setIsMobileMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="header" className={cn("sticky top-0 z-50 w-full transition-all duration-300 border-b border-transparent", isScrolled ? "bg-background/70 backdrop-blur-md shadow-sm border-border/40" : "bg-background")}>
      <div className="container mx-auto px-4 h-20 flex items-center justify-between">
        {}
        <Link to="/HomePage" className="flex items-center gap-3 flex-shrink-0">
          <img src="https://rolltreppenreinigung.yourbusiness.name/wp-content/uploads/2026/03/logo.jpg" alt="[PLATZHALTER: Logo]" className="h-8 w-auto object-contain" />
          <span className="text-sm font-bold tracking-wider text-foreground">SERVICE TEAM <br />WEINGARTEN</span>
        </Link>

        {}
        <div className="hidden lg:flex items-center gap-8">
          <MenuProvider menu_id="35">
            <DesktopMenuConsumer />
          </MenuProvider>
        </div>

        {}
        <div className="hidden lg:flex items-center gap-6">
          <Link to="tel:+49000000000" className="flex items-center gap-2 text-foreground font-bold hover:text-accent transition-colors">
            
            
          </Link>
          <Button asChild className="bg-accent text-accent-foreground hover:bg-accent/90 rounded-sm font-bold px-6 shadow-md transition-all">
            <Link to="/ContactPage">Angebot anfragen</Link>
          </Button>
        </div>

        {}
        <Button variant="ghost" size="icon" className="lg:hidden text-foreground hover:bg-muted" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu">
          {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </Button>
      </div>

      {}
      {isMobileMenuOpen && <div className="lg:hidden absolute top-full left-0 w-full bg-background border-b border-border shadow-xl animate-in slide-in-from-top-5 duration-200">
          <MenuProvider menu_id="35">
            <MobileMenuConsumer onClose={() => setIsMobileMenuOpen(false)} />
          </MenuProvider>
          <div className="p-4 border-t border-border flex flex-col gap-4 bg-muted/30">

          </div>
        </div>}
    </header>;
}